module.exports = __webpack_public_path__ + "static/media/sample.e9491074.xls";